<template>
  <div class="contact-vendor form-group">
    <p>Have you contacted {{lead.firstname}}?</p>
    <oa-button
      :text="'Yes, we\'ve spoken'"
      :btnClass="{ color: 'green' }"
      :disabled="disableSubmit"
      @click="hasContacted"
      gacategory="Lead"
    />
    <oa-button
      :text="'I called, no answer'"
      :btnClass="{ color: 'white', margin: 'left' }"
      :disabled="disableSubmit"
      @click="hasAttemptedToContact"
      gacategory="Lead"
    />
    <contact-attempts class="ut-mt-6" :contactAttempts="contactAttempts" />
  </div>
</template>

<script>

import { LeadAgentLeadStageType, LeadAgentLeadStageTypeId } from '@/Mapper/LeadAgentLeadStageType';
import OaButton from '@/components/Forms/OaButton';
import {
 mapState, mapActions, mapMutations, mapGetters 
} from 'vuex';
import ContactAttempts from '@/components/LeadAgentStageUpdates/ContactAttempts.vue';
import StageUpdate from '@/mixins/StageUpdate';

export default {
  name: 'ContactVendor',
  mixins: [StageUpdate],
  components: {
    OaButton,
    ContactAttempts,
  },
  computed: {
    ...mapState({
      agent: state => state.agentStore.agent,
      user: state => state.userStore.user,
      lam: state => state.leadAgentMappingStore.lam,
      lead: state => state.leadAgentMappingStore.lead,
    }),
    ...mapGetters('leadAgentMappingStore', [
      'lamStageIsLessThanAttempted',
      'lamStageIsLessThanContacted',
    ]),
  },
  created() {
    this.getContactAttempts();
  },
  data() {
    return {
      disableSubmit: false,
      contactAttempts: [],
    };
  },
  methods: {
    ...mapActions('leadAgentMappingStore', [
      'updateLeadAgentMapping',
    ]),
    ...mapMutations('leadAgentMappingStore', [
      'setLeadAgentMapping',
    ]),
    hasContacted() {
      this.disableSubmit = true;
      this.disableDefaultDisplay();
      // Set agent stage to attempted if stage is referred, accepted or attempted
      this.moveToContacted()
        .then(() => {
          this.logLeadEvent(
            'Leads Management - Submit status change - Contacted',
            'Single Deal Page - Post-Accepted',
          );
          this.disableSubmit = false;
        }).catch((err) => {
          this.disableSubmit = false;
          console.log(err);
        });
    },
    hasAttemptedToContact() {
      this.disableSubmit = true;
      // Create a new contact attempt with current date
      const contactAttemptData = {
        contactattemptinitiatortypeid: this.isLamOwner ? 2 : 3,
        contactattemptoutcometypeid: 3, // 1=Unknown 2=Success 3=No Contact 4=Left voicemail
        contactattemptdate: this.$helpers.formatDateTimeApi(new Date()),
        leadkey: this.lead.key,
        agentkey: this.$route.params.ak,
        // agentkey: this.agent.key,
      };
      this.$apiServices.oa.leadAgent.createContactAttempt(contactAttemptData)
        .then((result) => {
          if (result) {
            this.contactAttempts.push(result);
          }
          const updatedLam = this.lam;
          updatedLam.agentlastupdatedate = result.createddate;
          this.setLeadAgentMapping(updatedLam);
          // Set agent stage to attempted if stage is referred or accepted
          if (this.lamStageIsLessThanAttempted) {
            this.moveToAttempted()
              .then(() => {
                this.logLeadEvent(
                  'Leads Management - Submit status change - Attempted',
                  'Single Deal Page - Post-Accepted',
                );
                this.disableSubmit = false;
              }).catch((err) => {
                console.log(err);
                this.disableSubmit = false;
              });
          } else {
            this.disableSubmit = false;
          }
        });
    },
    getContactAttempts() {
      this.$apiServices.oa.leadAgent.getContactAttempts(this.$route.params.ak, this.$route.params.lk)
        .then((attempts) => {
          this.contactAttempts = !attempts ? [] : attempts;
        });
    },
    emitRefreshOpenedSections() {
      this.$emit('refresh-opened-sections');
    },
    disableDefaultDisplay() {
      this.$emit('disable-default-display');
    },
    moveToAttempted() {
      const data = {
        stagetypeid: LeadAgentLeadStageType.Attempted,
        sourcetypeid: this.isLamOwner ? 1 : 5,
      };
      return this.updateLeadAgentStage(data);
    },
    moveToContacted() {
      const data = {
        stagetypeid: LeadAgentLeadStageType.Contacted_Vendor,
        sourcetypeid: this.isLamOwner ? 1 : 5,
      };
      return this.updateLeadAgentStage(data);
    },
    updateLeadAgentStage(data) {
      if (!data.oauserid && !!this.user) {
        data.oauserid = this.user.id;
        data.oauserkey = this.user.key;
      }
      data.sourcetypeid = this.isLamOwner ? 1 : 5;
      const payload = {
        lamid: this.lam.id,
        data,
      };
      return this.updateLeadAgentMapping(payload);
    },
  },
};

</script>

<style lang="scss" scoped>

.btn {
  margin-bottom: 15px;
}

p {
  @apply ut-font-normal ut-text-lg ut-pb-3;
  line-height: 28px;
}

label {
  @apply ut-font-bold ut-text-sm ut-pb-3 ut-tracking-normal ut-pt-6;
  line-height: 24px;
}

.hint {
  @apply ut-text-sm ut-font-light ut-tracking-normal;
}

</style>
